import * as React from 'react';
import {useMemo} from 'react';

import {
    useResidenceExplorerStore,
    selectCurrentViewName,
    selectExplorer,
    selectSetup,
} from "features/residenceExplorer/store/useResidenceExplorerStore";
import {ImageSizes} from "@organisms/Shell/image-size-enum";

import './_residenceExplorerMobileNavigation.scss';

import {AsyncImage} from "@atoms/Media/AsyncImage";
import {keyboardClickable} from "components/hooks/keyboardClickable";
import {EpiImage} from "features/search/types";


export const ResidenceExplorerMobileNavigation: React.FunctionComponent = ({}) => {
    const setup = useResidenceExplorerStore(selectSetup);
    const explorer = useResidenceExplorerStore(selectExplorer);
    const currentViewName = useResidenceExplorerStore(selectCurrentViewName);
    const setCurrentViewName = useResidenceExplorerStore(state => state.setCurrentViewName);

    const thumbnails = useMemo(() => {
        if (!explorer?.settings || !setup) return {};
        const result: Record<string, EpiImage> = {};
        for (const key of Object.keys(explorer.views)) {
            const view = explorer.views[key];
            result[key] = {
                url: `/externalfiles/image/residenceexplorer/${setup.stageId}/${view.groupName}${view.imageSrc}`,
                orgHeight: explorer.settings.viewBoxHeight,
                orgWidth: explorer.settings.viewBoxWidth,
                ratio: explorer.settings.viewBoxWidth / explorer.settings.viewBoxHeight
            };
        }
        return result;
    }, [explorer, setup]);

    if(!explorer || !setup) return null;

    const changeView = (viewName: string) => () => {
        setCurrentViewName(viewName);
    };

    return (
        <div className="residence-explorer__mobile-nav">
            {Object.keys(explorer.views).map((key, index) => {
                return (
                    <div
                        {...keyboardClickable(changeView(key))}
                        key={`mobile-nav-${index}`}
                        className={`residence-explorer__mobile-item ${(currentViewName === key) ?
                            'residence-explorer__mobile-item--active' :
                            ''}`}
                    >
                        {
                            <AsyncImage
                                image={thumbnails[key]}
                                quality={ImageSizes.SIZE_300}
                                alt={`view ${key}`}
                                key={`view-${key}`}
                                noCrop
                            />
                        }
                    </div>
                )
            })}
        </div>
    );
};
